import { Button } from '@components/button';
import { Form, FormTextInput } from '@components/form';
import { useUploadVolumeDataMutation } from '@generated/graphql';
import { Stack } from '@mui/material';
import { useNotifications } from '@notifications/Notifications';
import * as yup from 'yup';

type CreateFolderModalProps = {
  directory: string[];
  volumeId: string;
  onClose: VoidFunction;
};

const validationSchema = yup.object({
  name: yup
    .string()
    .trim()
    .max(128, 'Must be less than 128 characters')
    .required('Name is required'),
});

export const CreateFolderModal = ({ directory, volumeId, onClose }: CreateFolderModalProps) => {
  const { useAsyncNotification } = useNotifications();
  const [addVolumeData] = useUploadVolumeDataMutation();

  const handleFormSubmit = useAsyncNotification(
    'Successfully created the folder.',
    async ({ name }: { name: string }) => {
      await addVolumeData({
        variables: {
          volumeId,
          key: `${directory.join('')}${name}/`,
          size: 0,
        },
      });
      onClose();
    },
  );

  return (
    <Form
      enableReinitialize
      onSubmit={handleFormSubmit}
      initialValues={{ name: '' }}
      validationSchema={validationSchema}
    >
      {({ isValid, handleSubmit, dirty, isSubmitting }) => (
        <Stack>
          <FormTextInput label="Name" name="name" />
          <Stack gap={4}>
            <Button
              fullWidth
              loading={isSubmitting}
              disabled={!(isValid && dirty && !isSubmitting)}
              type="submit"
              onClick={() => handleSubmit()}
            >
              Save
            </Button>
            <Button fullWidth variant="secondary" onClick={onClose}>
              Cancel
            </Button>
          </Stack>
        </Stack>
      )}
    </Form>
  );
};
